function yMetrica(ev) {
	ym(97220453, 'reachGoal', ev);
}


document.addEventListener('DOMContentLoaded', function () {


	// document.querySelectorAll('.faq__trigger').forEach((item, i) => {
	// 	item.addEventListener('click', (e) => {
	// 		setTimeout(() => {
	// 			if (item.classList.contains('m-active')) {
	// 				yMetrica(`click__faq_${i + 1}`);
	// 			}
	// 		}, 10);
	// 	});
	// });

	// document.querySelector('.nav__link[href="#reg"]').addEventListener('click', (e) => {
	// 	yMetrica('click__registraciya_1');
	// });

	// document.querySelector('.nav__link[href="#what"]').addEventListener('click', (e) => {
	// 	yMetrica('click__chto_budet');
	// });

	// document.querySelector('.nav__link[href="#faq"]').addEventListener('click', (e) => {
	// 	yMetrica('click__faq');
	// });

	// document.querySelector('.hero__btns [href="#reg"]').addEventListener('click', (e) => {
	// 	yMetrica('click__registraciya_2');
	// });

	// document.querySelector('.faq .btn[href="#reg"]').addEventListener('click', (e) => {
	// 	yMetrica('click__registraciya_3');
	// });

	document.querySelector('.schedule .btn[href="#reg"]').addEventListener('click', (e) => {
		yMetrica('click__registraciya_1');
	});


	document.querySelector('.footer__soc-link[title="Telegram"]').addEventListener('click', (e) => {
		yMetrica('click__tg');
	});
	// document.querySelector('.footer__soc-link[title="VK"]').addEventListener('click', (e) => {
	// 	yMetrica('click__vk');
	// });
	// document.querySelector('.footer__soc-link[title="YouTube"]').addEventListener('click', (e) => {
	// 	yMetrica('click__yt');
	// });

	document.querySelector('.contact a[href*="mailto:"]').addEventListener('click', (e) => {
		yMetrica('click__email');
	});



});